import { PropsWithChildren } from 'react';

type SpanProps = {
  className?: string;
  onClick?: () => void;
  dataTestId?: string;
  style?: any;
  forceRender?: boolean;
};

const Span = ({
  children,
  className,
  dataTestId,
  style,
  forceRender,
  ...restProps
}: PropsWithChildren<SpanProps>) => {
  if (!children && !forceRender) return null;
  return (
    <span className={className} data-testid={dataTestId} style={style} {...restProps}>
      {children}
    </span>
  );
};

export default Span;
